export default __webpack_public_path__ + "static/media/Machine-Learning-EN.286184d8.jpg";